module.exports = __webpack_public_path__ + "assets/img/ArtyMirror_cover.6cdbc533-ps.jpg";